import { gql } from '@apollo/client';

/* ----- Query ----- */
const ownerTypeDefs = `
  name
  email
  image
`

const courseTypeDefs = `
  id

  title
  description
  owner {
    ${ownerTypeDefs}
  }

  price
  lectureType
  language

  lectureVideo
  learnOutcomes
  purchasedUsers
  reviews {
    name
    image
    message
    created
    reviewScore
  }

  created
`

const documentTypeDefs = `
  id

  title
  description

  price
  lectureType
  language

  lecturePdf
  learnOutcomes
  purchasedUsers
  reviews {
    name
    image
    message
    created
    reviewScore
  }

  created
`

const GET_PLATFORM_INFO = gql`
  query Query {
    getPlatformInfo {
      minPrice
      maxPrice
      minWithdraw
      totalEarning
      platformFee
	  }
  }
`

const GET_WITHDRAW_HISTORY = gql`
  query Query {
    getUserWithdrawHistory {
      id
      user {
        id
        ${ownerTypeDefs}
      }

      amount
      currency
      status

      created
      lasttime
    }
  }
`

const GET_INSTRUCTOR = gql`
  query Query {
    getInstructor {
      id

      name
      email
      userType

      image
      coverImage
      location
      bio

      github
      linkedin
      twitter

      totalEarning
      totalStudents
    }
  }
`

const GET_BROWSE_COURSE = gql`
  query Query($lectureType: String!) {
    getBrowseCourse(lectureType: $lectureType) {
      ${courseTypeDefs}
    }
  }
`
const GET_DOCUMENTS = gql`
  query Query {
    getDocuments {
      id
      title
      description
      owner {
        ${ownerTypeDefs}
      }
      price
      language
      lectureType
      created
    }
  }
`   

const GET_COURSEDetail = gql`
  query Query($id: String!) {
    getCourseData(id: $id) {
      ${courseTypeDefs}

      isOwner
      isReview
      isSubscribe
      subscribed
      questionAnswers {
        id
        user {
          ${ownerTypeDefs}
        }

        question
        answer
        questionTime
        answerTime
      }
    }
  }
` 

const GET_DocumentDetail = gql`
  query Query($id: String!) {
    getDocumentData(id: $id) {
      ${documentTypeDefs}
    }
  }
` 

export {
  GET_PLATFORM_INFO,
  GET_WITHDRAW_HISTORY,
  GET_BROWSE_COURSE,
  GET_COURSEDetail,
  GET_INSTRUCTOR,
  GET_DOCUMENTS,
  GET_DocumentDetail
}